export const REDUCER_KEY = 'features/material-list';
